"use client"

import * as React from "react"
import {
  Button,
  EmojiPicker,
  EmojiPickerContent,
  EmojiPickerFooter,
  EmojiPickerSearch,
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@ui/shad"
import { cn } from "@ui/utils"
import { SmilePlus } from "lucide-react"

interface EmojiPickerPopoverProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  onEmojiSelect: (emoji: string) => void
  iconClassName?: string
}

export function EmojiPickerPopover({ onEmojiSelect, open, onOpenChange, iconClassName }: EmojiPickerPopoverProps) {
  const handleEmojiSelect = (emoji: { emoji: string; label: string }) => {
    onEmojiSelect(emoji.emoji)
    onOpenChange(false)
  }

  return (
    <Popover onOpenChange={onOpenChange} open={open} modal>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="iconXs" className="hover:bg-muted">
          <SmilePlus className={cn("text-icon-muted !size-3", iconClassName)} />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-fit p-0" side="right">
        <EmojiPicker className="h-[342px]" onEmojiSelect={handleEmojiSelect}>
          <EmojiPickerSearch />
          <EmojiPickerContent />
          <EmojiPickerFooter />
        </EmojiPicker>
      </PopoverContent>
    </Popover>
  )
}
